<app-overlay
  *ngIf="isLoading"
  [overlayIsLoading]="true"
></app-overlay>
<router-outlet></router-outlet>
